/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import { Col, Row } from 'react-bootstrap'
import useWindowSize from '@shared/hooks/windowSize'
import CustomLink from '@shared/components/customLink'

const HILTimeLine = ({ data, teamData }) => {
  const [filter, setFilter] = useState('Men')
  const [width] = useWindowSize()

  const teamDataToMap = filter === 'Men' ? teamData?.filter(d => d?.gender === 'male') : teamData?.filter(d => d?.gender === 'female')

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Previous Winners </h2>
      <div className={`${styles.timeline} scroll-list`}>
        {data?.map((d, i) => (
          <div key={d.date} className={styles.dateColumn}>
            <div className={`${styles.dateNode} ${i === data?.length - 1 ? styles.active : ''}`}>
              <span />
            </div>
            <div className={`${styles.dateLabel}`}>{d?.season}</div>
            <div className={styles.matches}>
              <div className={styles.match}>
                <div
                  className={`${styles.teamLogos} ${
                    d?.season === 2024 ? 'justify-content-center text-center' : 'justify-content-center gap-2 text-start'
                  }`}>
                  {d?.season !== 2024 && (
                    <div className={`${styles.team} w-full d-flex text-center align-items-center flex-column w-75`}>
                      <MyImage src={d?.teamLogo} alt="Continental Kings" height={42} width={42} />
                    </div>
                  )}

                  <div className="d-flex flex-column  w-100">
                    <span className={styles.teamTitle}>{d?.season === '2024' ? 'TBA' : d?.teamName}</span>
                    <span className={styles.vsText}>{`Winner, ${d.season}`} </span>
                  </div>
                </div>
                <div className={`${styles.matchDetail} text-center p-2`}>
                  <div className={styles.matchTime}>
                    <div className={styles.timeTitle}>Season</div>
                    <div className={styles.timeValue}>{d?.season}</div>
                  </div>
                  <div className={styles.matchTimePlayer}>
                    <div className={styles.timeTitle}>Best Player</div>
                    <div className={styles.timeValue}>{d?.date === '2024' ? 'TBD' : d?.bestPlayer}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {width > 767 && (
        <>
          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center w-100">
              <h2 className={`${styles.title} mt-0`}>Teams</h2>
              <div className={styles.filterContainer}>
                <button
                  className={`${styles.filterButton} ${filter === 'Men' ? styles.activeFilter : ''}`}
                  onClick={() => setFilter('Men')}>
                  Men
                </button>
                <button
                  className={`${styles.filterButton} ${filter === 'Women' ? styles.activeFilter : ''}`}
                  onClick={() => setFilter('Women')}>
                  Women
                </button>
              </div>
            </div>
            <div>
              <Row>
                {teamDataToMap?.map((a, i) => {
                  if (a?.articleSlug) {
                    return (
                      <CustomLink key={i} href={`/${a?.articleSlug}`}>
                        <Col lg={3} sm={6}>
                          <>
                            <div className={`${styles.teamContainer} cursor-pointer`}>
                              <MyImage src={a?.logo} height={150} width={150} />
                            </div>
                            <h6 className={styles.teamName}>{a?.teamName}</h6>
                          </>
                        </Col>
                      </CustomLink>
                    )
                  } else {
                    return (
                      <Col lg={3} sm={6} key={i}>
                        <>
                          <div className={`${styles.teamContainer}`}>
                            <MyImage src={a?.logo} height={150} width={150} />
                          </div>
                          <h6 className={styles.teamName}>{a?.teamName}</h6>
                        </>
                      </Col>
                    )
                  }
                })}
              </Row>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default HILTimeLine
